import { Market } from 'BrokerTsLib/src/enums'
import type { IPartnerSettings } from '.'

export const Respect: IPartnerSettings = {
  partner: 'Respect',
  hosts: [
    'kara-kal.cz'
    , 'www.kara-kal.cz'
    // , 'localhost:44470'
  ],
  market: Market.CZ
}
